<template>
  <div>
      <h3>Manage ISV </h3>
      <div class="row">
        <!-- <div class="col-md-6"> -->
        <LocationISVInfo />
        <!-- </div> -->
      </div>
      <div class="row">
        <!-- <div class="col-md-6"> -->
        <UploadNumberPricing />
        <!-- </div> -->
      </div>
      <div class="row">
        <HandleNumberMigration />
      </div>
      <div class="row">
        <!-- <div class="col-md-6"> -->
        <LocationTwilioCredSync />
        <!-- </div> -->
      </div>

      <div class="row">
        <!-- <div class="col-md-6"> -->
        <UpdateSMSLimit />
        <!-- </div> -->
      </div>

      <div class="row">
        <!-- <div class="col-md-6"> -->
        <PhoneInfo />
        <!-- </div> -->
      </div>
      <div class="row">
        <LocationNumberRateLimit />
      </div>
      <div class="row">
        <!-- <div class="col-md-6"> -->
        <DisableISVLocation />
        <!-- </div> -->
      </div>
      <div class="row">
        <MoveAgencyOutOfISV />
      </div>
      <div class="row">
        <SyncBrandAndCampaign />
      </div>
      <div class="row">
        <DeleteTollFreeTicket />
      </div>
      <div class="row">
        <AddBusinessProfileFailureReason />
      </div>
      <div class="row">
        <!-- <div class="col-md-6"> -->
        <EntityDataTwilioSID />
        <!-- </div> -->
      </div>
      <!-- <div class="row">
        <MigrateToLCEmail />
      </div> -->
      <div class="row">
        <SendingLimitFeature />
      </div>
      <!-- <div class="row">
        <FlushDmarcPolicy />
      </div> -->
      <!-- <div class="row">
        <EmailVerification />
      </div> -->
      <div class="row">
        <BlockFeature/>
      </div>
       <div class="row">
        <EnableBlockedFeatures />
      </div>
      <div class="row">
        <ResetContactDND/>
      </div>
      <div class="row">
        <DebitCompanyWalletVue/>
      </div>
      <!-- <div class="row">
        <FindLocationAndAgencyUsingDomain />
      </div> -->
      <div class="row">
        <CRTokenRemove />
      </div>
      <div class="row">
        <SkipPaymentVerificationAndEnableISV />
      </div>
      <div class="row">
        <CallerIdVerificationLimit />
      </div>
      <div class="row">
        <AllowAgencyUpdateUsageLimit />
      </div>
      <div class="row">
        <UnBlockInboundCall />
      </div>
      <div class="row">
        <SkipPaymentVerificationPurchaseNumber />
      </div>
      <div class="row">
        <CleanUpTwilio />
      </div>
      <div class="row" v-if="isISVL4">
        <BulkSuspendTwilioAccounts />
      </div>
      <div class="row">
        <BypassChatWidgetBlock />
      </div>
  </div>
</template>

<script>
import LocationISVInfo from "./LocationISVInfo.vue";
import UploadNumberPricing from "./UploadNumberPricing.vue";
import DisableISVLocation from './DIsableISVLocation.vue';
import DeleteTollFreeTicket from './DeleteTollFreeTicket.vue';
import EntityDataTwilioSID from './EntityDataTwilioSID.vue';
import FlushDmarcPolicy from './FlushDmarcPolicy.vue';
import MigrateToLCEmail from './MigrateToLCEmail.vue';
import EnableBlockedFeatures from './EnableBlockedFeatures.vue';
import BlockFeature from './BlockFeature.vue';
import ResetContactDND from './ResetContactDND.vue';
import DebitCompanyWalletVue from './DebitCompanyWallet.vue';
import PhoneInfo from './PhoneInfo.vue';
import MoveAgencyOutOfISV from './MoveAgencyOutOfISV.vue';
import AddBusinessProfileFailureReason from './AddBusinessProfileFailureReason.vue';
import EmailVerification from './EmailVerification.vue';
import SendingLimitFeature from "./SendingLimitFeature.vue";
import FindLocationAndAgencyUsingDomain from './FindLocationAndAgencyUsingDomain';
import SkipPaymentVerificationAndEnableISV from './SkipPaymentVerificationAndEnableISV'
import CallerIdVerificationLimit from './CallerIdVerificationLimit'
import AllowAgencyUpdateUsageLimit from './AllowAgencyUpdateUsageLimit'
import CRTokenRemove from './CRTokenRemove';
import SyncBrandAndCampaign from './SyncBrandAndCampaign';
import CleanUpTwilio from './CleanUpTwilio'
import BypassChatWidgetBlock from './BypassChatWidgetBlock.vue'
import LocationTwilioCredSync from './LocationTwilioCredSync.vue';
import UpdateSMSLimit from './UpdateSMSLimit.vue';
import UnBlockInboundCall from './UnBlockInboundCall.vue';
import SkipPaymentVerificationPurchaseNumber from "./SkipPaymentVerificationPurchaseNumber.vue";
import HandleNumberMigration from './HandleNumberMigration.vue';
import BulkSuspendTwilioAccounts from './BulkSuspendTwilioAccounts.vue';
import LocationNumberRateLimit from './LocationNumberRateLimit.vue';
import { mapGetters } from "vuex";
import { Module, Role } from "@/constants";

export default {
  computed: {
    ...mapGetters("auth", ["userHasPermission"]),
    isISVL4() {
      return this.userHasPermission(Module.ISV, Role.L4)
    }
  },
  components: {
    LocationISVInfo,
    UploadNumberPricing,
    DisableISVLocation,
    EntityDataTwilioSID,
    FlushDmarcPolicy,
    MigrateToLCEmail,
    EnableBlockedFeatures,
    BlockFeature,
    ResetContactDND,
    DebitCompanyWalletVue,
    PhoneInfo,
    MoveAgencyOutOfISV,
    AddBusinessProfileFailureReason,
    EmailVerification,
    SendingLimitFeature,
    DeleteTollFreeTicket,
    FindLocationAndAgencyUsingDomain,
    CRTokenRemove,
    SkipPaymentVerificationAndEnableISV,
    CallerIdVerificationLimit,
    LocationTwilioCredSync,
    SyncBrandAndCampaign,
    AllowAgencyUpdateUsageLimit,
    UnBlockInboundCall,
    SkipPaymentVerificationPurchaseNumber,
    CleanUpTwilio,
    BypassChatWidgetBlock,
    UpdateSMSLimit,
    HandleNumberMigration,
    BulkSuspendTwilioAccounts,
    LocationNumberRateLimit
  }
}
</script>

<style>

</style>
